// extracted by mini-css-extract-plugin
module.exports = {"statusSuccess":"StatusAvatar_statusSuccess__3eInE","statusLoading":"StatusAvatar_statusLoading__2qdpk","statusError":"StatusAvatar_statusError__1RYw4"};